export default __webpack_public_path__ + "static/media/1.24fb68a1.svg";